/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { Redirect } from "react-router";

import type { EventInfo } from "../../utility";
import type { VideoErrorType } from "hooks/video/VideoAuthenticator";
import type { RedirectState } from "modules/router";

/**
 * エラーによる振る舞いを行う
 * - チケットが未購入だったら、チケット購入が必要というポップアップを出し、イベントページにリダイレクト。
 * - 配信ページが閉場だったら、配信は終了したというポップアップを出し、イベントページにリダイレクト。
 * - 予期しないエラーだったら、エラーポップアップを出し、イベントページにリダイレクト。
 * - TODO: getErrorだったら
 * @returns
 */
export const VideoErrorBehavior: React.FC<{
  displayEvent: EventInfo;
  error: VideoErrorType;
}> = (props) => {
  const { t } = useI18n();
  if (props.error === "notStreamPageOpen") {
    const redirectState: RedirectState = {
      noticeCaption: t("streaming.authenticator.unavailable"),
      noticeMsg: t("streaming.authenticator.unavailableCaution"),
    };
    return (
      <Redirect
        to={{
          pathname: `/events/${props.displayEvent._id}`,
          state: redirectState,
        }}
      />
    );
  }
  if (props.error === "needTicket") {
    const redirectState: RedirectState = {
      noticeCaption: t("streaming.authenticator.needTicket"),
      noticeMsg: t("streaming.authenticator.needTicketCaution"),
    };
    return (
      <Redirect
        to={{
          pathname: `/events/${props.displayEvent._id}`,
          state: redirectState,
        }}
      />
    );
  }
  if (props.error === "unknown") {
    const redirectState: RedirectState = {
      noticeCaption: "予期せぬエラーが発生しました",
      noticeMsg:
        "ログインアカウントをご確認のうえ、時間を置いて再度お試しください。",
    };
    return (
      <Redirect
        to={{
          pathname: `/events/${props.displayEvent._id}`,
          state: redirectState,
        }}
      />
    );
  }
};
